module.exports = __webpack_public_path__ + "media/images/registrations/info_version/info-1-49668607a6e68101cd962ffb4651cdf2.png";